export default ({...props}) => {
  const {palette, size, space} = props.theme
  return `
    background-color: ${palette.common.white};
    .MuiCardHeader-root{
      .MuiTypography-root{
        margin-bottom: ${space(1)}px;
        &:last-child{
          padding-bottom: 0px;
          margin-bottom: 0px;
        }
      }
    }
    .card-delivery-details-actions{
      &>button{
        &:hover,
        &:focus{
          .MuiCardActionArea-focusHighlight{
            background: none;
          }
        }
       
      }
    }
    .MuiCardActionArea-root{
      padding:0px;
    }
    .MuiCardContent-root{
      padding-top: 0px;

      & > [ap_type="row"]{
        justify-content:space-between;
        & > * {
          width: 45%;
          &:first-child{
            padding-left: 0px;
          }
          .delivery-actions{
             &>*:first-child{
            padding-left: 0px;
          }
          }
          
        }

        @media only screen and (max-width: 720px) {
         flex-direction: column-reverse;
          & > * {
            width: 100%;
          }
        }
      }
      .MuiStepper-root{
        margin-bottom: ${size(2.5)}px;
      }
      .MuiTypography-body1{
        line-height: inherit;
      }
    }
    .MuiCardHeader-root{
      padding-bottom: 0px;
    }
    .MuiCardHeader-action{
      width:40%;
      disableRipple:true;
      & [ap_type="primary"]
      {
        width:100%;
      }
      .MuiTypography-body1{
        display: flex
      }
    }
  `
}
